import "./LocationTestAndPanelsEditComponent.scss";
import TabsWrapperComponent, {
    TabComponent,
    TabContentComponent,
    TabsComponent
} from "../../../../../shared/components/tabs/tabsComponent";
import CheckBoxComponent from "../../../../../shared/components/core/checkbox/CheckboxComponent";
import commonService from "../../../../../shared/services/common.service";
import StatusCardComponent from "../../../../../shared/components/status-card/statusCardComponent";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import DrawerComponent from "../../../../../shared/components/drawer/drawerComponent";
import React, {useCallback, useEffect} from "react";
import {useSelector} from "react-redux";
import TestDetailsComponent from "../../../../../shared/components/test-details/TestDetailsComponent";

interface LocationTestAndPanelsEditComponentProps {
    locationTestAndPanel: any;
    canEdit: boolean;
    onEditCancel: () => void;
    onUpdateComplete: Function;
    locationId: string;
    labTest: any;
    labPanel: any;
}

const TESTS = 'tests';
const TEST_PANELS = 'test_panels';

const LocationTestAndPanelsEditComponent = (props: LocationTestAndPanelsEditComponentProps) => {
    const {locationTestAndPanel, locationId, labPanel, labTest, onEditCancel, onUpdateComplete} = props;

    const [isEdited, setIsEdited] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState<typeof TESTS | typeof TEST_PANELS>(TESTS);
    const {testListLite, biomarkerList} = useSelector((state: any) => state.staticData);
    const [viewDetailsDrawerOpen, setViewDetailsDrawerOpen] = React.useState(false);
    const [testOrPanelDetails, setTestOrPanelDetails] = React.useState<any>(undefined); // [testOrPanelDetails, setTestOrPanelDetails
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [selectedTestAndTestPanelIds, setSelectedTestAndTestPanelIds] = React.useState<any>({
        testIds: [],
        panelIds: []
    });


    useEffect(() => {
        if (locationTestAndPanel?.panelDetails?.length > 0 || locationTestAndPanel?.testDetails?.length > 0) {
            setIsEdited(true);
            setSelectedTestAndTestPanelIds(() => {
                return {
                    testIds: locationTestAndPanel?.testDetails,
                    panelIds: locationTestAndPanel?.panelDetails
                }
            });
        }
    }, [locationTestAndPanel]);

    const handleActiveTabChange = useCallback((tab: any) => {
        setActiveTab(tab);
    }, []);

    const handleViewDetailsDrawerOpen = useCallback((details: any) => {
        if (activeTab === TEST_PANELS) {
            const testNames = details?.testIds?.map((testId: any) => {
                const test = testListLite?.find((test: any) => test?.id === testId);
                return test.name;
            });
            const testObject = {...details, tests: testNames};
            setTestOrPanelDetails(testObject);
        } else {
            const biomarkerNames = details?.biomarkerIds?.map((biomarkerId: any) => {
                const biomarker = biomarkerList?.find((biomarker: any) => biomarker?.id === biomarkerId);
                return biomarker?.name;
            });
            setTestOrPanelDetails({...details, biomarkers: biomarkerNames});
        }
        setViewDetailsDrawerOpen(true);
    }, [testListLite, activeTab, biomarkerList]);

    const addLocationTestAndPanels = useCallback(() => {
        setIsSubmitting(true);
        const payload = {
            testIds: selectedTestAndTestPanelIds?.testIds?.map((test: any) => test?.id),
            panelIds: selectedTestAndTestPanelIds?.panelIds?.map((panel: any) => panel?.id)
        }
        commonService._location.addLocationTestAndPanels(locationId, payload)
            .then((res: any) => {
                onUpdateComplete({
                    testDetails: selectedTestAndTestPanelIds?.testIds,
                    panelDetails: selectedTestAndTestPanelIds?.panelIds
                });
                setIsSubmitting(false);
            })
            .catch((err: any) => {
                setIsSubmitting(false);
            });
    }, [locationId, selectedTestAndTestPanelIds, onUpdateComplete]);

    return (
        <div className={'location-test-and-panels-edit-component  details-tab-data-content'}>
            <form>
                <div className="t-form-controls-wrapper assign-lab-to-test-location-tab">
                    <TabsWrapperComponent>
                        <TabsComponent
                            value={activeTab}
                            allowScrollButtonsMobile={false}
                            variant={"fullWidth"}
                            onUpdate={(e: any, v: any) => {
                                handleActiveTabChange(v)
                            }}
                        >
                            <TabComponent label={"TESTS"} value={"tests"}/>
                            <TabComponent label={"Test panels"} value={'test_panels'}/>
                        </TabsComponent>
                        <TabContentComponent selectedTab={activeTab} value={TESTS}>
                            {
                                labTest?.length > 0 ?
                                    labTest.map((test: any, index: any) => {
                                            return (
                                                <div key={index} className={'lab-list-item'}>
                                                    <div className={'lab-list-item-name-and-selection'}>
                                                        <CheckBoxComponent
                                                            checked={selectedTestAndTestPanelIds?.testIds?.find((testId: any) => testId?.id === test?.testId)}
                                                            disabled={!test?.isActive || !test?.testDetail?.isActive}
                                                            onUpdate={(isChecked: boolean) => {
                                                                setIsEdited(true)
                                                                if (isChecked) {
                                                                    setSelectedTestAndTestPanelIds((prevState: any) => {
                                                                            return {
                                                                                ...prevState,
                                                                                testIds: [...prevState?.testIds, test?.testDetail]
                                                                            }
                                                                        }
                                                                    )

                                                                } else {
                                                                    //remove the test from the selected list with the id filter
                                                                    setSelectedTestAndTestPanelIds((prevState: any) => {
                                                                        return {
                                                                            ...prevState,
                                                                            testIds: prevState?.testIds?.filter((id: any) => test?.testId !== id?.id)
                                                                        }
                                                                    });
                                                                }
                                                            }}
                                                            name={commonService.capitalizeFirstLetterOfEachWord(test?.testDetail?.name)}
                                                        />
                                                        <div className={'lab-list-item-name'}>
                                                            {commonService.capitalizeFirstLetterOfEachWord(test?.testDetail?.name)}
                                                        </div>
                                                    </div>
                                                    <div className={'lab-list-item__action'}>
                                                        <div className={'underline-button'} onClick={() => {
                                                            handleViewDetailsDrawerOpen(test?.testDetail);
                                                        }}>
                                                            View Details
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    ) :
                                    <StatusCardComponent title={"No tests found"}/>
                            }
                        </TabContentComponent>
                        <TabContentComponent selectedTab={activeTab} value={TEST_PANELS}>
                            {
                                labPanel && labPanel.length > 0 ?
                                    labPanel.map((testPanel: any, index: number) => {
                                            return (
                                                <div key={index} className={'lab-list-item'}>
                                                    <div className={'lab-list-item-name-and-selection'}>
                                                        <CheckBoxComponent
                                                            checked={selectedTestAndTestPanelIds?.panelIds?.find((panelId: any) => panelId?.id === testPanel?.panelId)}
                                                            disabled={!testPanel?.isActive || !testPanel?.panelDetail?.isActive}
                                                            onUpdate={(isChecked: boolean) => {
                                                                setIsEdited(true)
                                                                if (isChecked) {
                                                                    setSelectedTestAndTestPanelIds((prevState: any) => {
                                                                        return {
                                                                            ...prevState,
                                                                            panelIds: [...prevState?.panelIds, testPanel?.panelDetail]
                                                                        }
                                                                    });
                                                                } else {

                                                                    setSelectedTestAndTestPanelIds((prevState: any) => {
                                                                        return {
                                                                            ...prevState,
                                                                            panelIds: prevState?.panelIds?.filter((id: any) => testPanel?.panelId !== id?.id)
                                                                        }
                                                                    });
                                                                }
                                                            }}
                                                            name={commonService.capitalizeFirstLetterOfEachWord(testPanel?.panelDetail?.name)}
                                                        />
                                                        <div className={'lab-list-item-name'}>
                                                            {commonService.capitalizeFirstLetterOfEachWord(testPanel?.panelDetail?.name)}
                                                        </div>
                                                    </div>
                                                    <div className={'lab-list-item__action'}>
                                                        <div className={'underline-button'} onClick={() => {
                                                            handleViewDetailsDrawerOpen(testPanel.panelDetail);
                                                        }}>
                                                            View Details
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    ) :
                                    <StatusCardComponent title={"No test panels found"}/>
                            }
                        </TabContentComponent>
                    </TabsWrapperComponent>
                </div>
                <div className='form-action-section-edit'>
                    <ButtonComponent
                        className={"width-25 "}
                        type="button"
                        color={"secondary"}
                        variant={"outlined"}
                        fullWidth={false}
                        disabled={isSubmitting}
                        handleClick={() => onEditCancel()}
                    >
                        Cancel
                    </ButtonComponent>
                    <ButtonComponent
                        className={"width-25"}
                        type="button"
                        color={"primary"}
                        variant={"contained"}
                        fullWidth={false}
                        disabled={!isEdited}
                        isLoading={isSubmitting}
                        handleClick={() => addLocationTestAndPanels()}
                    >
                        Save
                    </ButtonComponent>
                </div>
            </form>
            <DrawerComponent
                title={''}
                open={viewDetailsDrawerOpen}
                onClose={() => {
                    setViewDetailsDrawerOpen(false)
                }}
            >
                <TestDetailsComponent TESTS={TESTS} testOrPanelDetails={testOrPanelDetails} TEST_PANELS={TEST_PANELS}
                                      activeTab={activeTab}/>
            </DrawerComponent>
        </div>
    );

};

export default LocationTestAndPanelsEditComponent;
